import { render, staticRenderFns } from "./ques71.vue?vue&type=template&id=a3810686&scoped=true"
import script from "./ques71.vue?vue&type=script&lang=js"
export * from "./ques71.vue?vue&type=script&lang=js"
import style0 from "./ques71.vue?vue&type=style&index=0&id=a3810686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3810686",
  null
  
)

export default component.exports